import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {
	selectIomoDesign, selectIomoReflectorColour, selectIomoReflectorColourInclCustom,
} from '../iomoSelectors';
import {iomoReflectorColourOptions} from '../iomoModel';
import {setIomoHeadsData, setIomoReflectorColour} from '../iomoSlice';

@customElement('iomo-general-surface-settings')
export class IomoGeneralSurfaceSettings extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--small-padding);
			}
			.box {
				background-color: var(--color-widget-background);
				padding: 12px;
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--large-space);
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		console.log('IomoGeneralSurfaceSettings stateChanged');
	}

	setAllReflectorColours(value) {
		const heads = Array.from({length: 8}, (_, i) => ({reflectorColour: value}));
		store.dispatch(setIomoHeadsData({heads: heads})); // all Heads
		store.dispatch(setIomoReflectorColour({id: value})); // general
	}
	reflectorColourCanBeSelected(state, id) {
		return (id !== 'custom');
	}
	render() {
		return html`
			<color-editions></color-editions>

			<spc-attribute attributeId="root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour" .hideDisabled=${true}></spc-attribute>

			<list-select
				.title=${{de: 'Reflektorfarbe', en: 'Reflector Colour', fr: 'couleur réflecteur'}}
				.options=${iomoReflectorColourOptions}
				.callback=${(value) => this.setAllReflectorColours(value)}
				.selected=${selectIomoReflectorColour}
				.canBeSelected=${this.reflectorColourCanBeSelected}
				.isSatisfied=${() => true}>
			</list-select>
		`;
	}
}
